'use client'

import { useLingui } from '@lingui/react/macro'
import { NewspaperIcon } from 'lucide-react'

import { PageSidebar, useFilterPosts } from '~/components/blog/page-sidebar'
import { PostCard } from '~/components/blog/post-card'
import { type Post } from '~/domains/blog/list-posts'

export const PostsGrid = ({
	domain,
	posts,
}: {
	domain: 'blog' | 'use-cases'
	posts: Post[]
}) => {
	const { t } = useLingui()
	const filteredPosts = useFilterPosts(posts)

	return (
		<div className='grid grid-cols-1 items-start gap-4 md:grid-cols-3'>
			<div className='col-span-2 flex flex-col gap-4'>
				{filteredPosts?.map((post) => (
					<PostCard
						domain={domain}
						key={post.id}
						post={post}
					/>
				))}

				{!filteredPosts?.length && (
					<div className='flex flex-col items-center justify-center gap-2 py-8'>
						<NewspaperIcon className='text-muted-foreground !size-10' />
						<p className='text-muted-foreground'>{t`Aucun article trouvé`}</p>
					</div>
				)}
			</div>

			<PageSidebar posts={filteredPosts} />
		</div>
	)
}
